import THEME from 'pobble-components/dist/theme'
import { hover } from 'pobble-components/dist/jss-mixins'

const { COLORS } = THEME

export default {
  button: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold',
    cursor: 'pointer',
    ...hover({
      color: COLORS.BLUE.FADED
    }),
    '&:active': {
      color: COLORS.BLUE.NORMAL
    }
  },
  deselect: {
    color: COLORS.RED.FADED,
    ...hover({
      color: COLORS.RED.EXTRA_FADED
    }),
    '&:active': {
      color: COLORS.RED.FADED
    }
  }
}
